import { render, staticRenderFns } from "./WithdrawalAttachments.vue?vue&type=template&id=8981b7d8&scoped=true"
import script from "./WithdrawalAttachments.vue?vue&type=script&lang=js"
export * from "./WithdrawalAttachments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8981b7d8",
  null
  
)

export default component.exports